import { render, staticRenderFns } from "./warning.vue?vue&type=template&id=9996f5ca&scoped=true&lang=pug&"
import script from "./warning.vue?vue&type=script&lang=ts&"
export * from "./warning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9996f5ca",
  null
  
)

export default component.exports